export default {"src":"/_next/static/media/b2Tech.a5d270d8.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};